/**
 * Application constants
 * Single source of truth for app-wide values
 */

export const APP_NAME = {
  /** Full app name with Arabic */
  full: 'Klamantina | كلمنتينا',
  /** English/Latin name only */
  en: 'Klamantina',
  /** Arabic name only */
  ar: 'كلمنتينا',
} as const

export const APP_META = {
  title: APP_NAME.full,
  description: 'Egyptian Arabic word alternative suggestion platform',
} as const
